<template>
  <NuxtLayout class="app-entry" :name="envStore.isMobile ? 'mobile' : 'default'">
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useNuxtApp, useHead } from '#imports';
import { useSSRContext } from 'vue';
import { useEnvironmentStore } from './src/store';
import { getRuntimeContext } from './server/helpers/server';
import { useUserStore } from './src/store/modules/user';
import { isMobile, getPlatform } from './server/utils/device';
import { miniProgramToPc } from './src/api/modules/exam';
import { getUrlQuery } from '@/src/utils/urlHelper';
import { APIEventEmitter } from '~/src/services/event';
import { EventNameMap } from '~/src/services/event/constants';
import { useAppSettingStore } from './src/store/modules/app-setting';
import { GLOBAL_CONFIG } from '~/configs/environment/environment';

import { useUserCenterStore } from '@/src/store/modules/user-center/index'; // app和小程序更新subject
import { HostRouteParamsEnum, StorageKeyEnum } from './src/constants/user';
import { PlatformEnum } from './src/store/modules/environment/types';

const nuxtApp = useNuxtApp();

const envStore = useEnvironmentStore();
// 全局用户信息
const userStore = useUserStore();

const appSettingStore = useAppSettingStore();
const UserCenterStore = useUserCenterStore();
const route = useRoute();

if (process.server) {
  const ssrContext = useSSRContext();
  const runtimeContext = getRuntimeContext(ssrContext?.event);
  console.log('runtimeContext.isMobile', runtimeContext.isMobile);
  envStore.setIsMobile(runtimeContext.isMobile);
  envStore.setPlatform(runtimeContext.platform);
}

if (envStore.isMobile === undefined) {
  envStore.setIsMobile(isMobile(navigator?.userAgent));
}

if (!envStore.platform) {
  envStore.setPlatform(getPlatform(navigator?.userAgent || ''));
}

console.log('platform', envStore.platform);

if (envStore.platform === PlatformEnum.MINI_PROGRAM) {
  // 小程序环境 登录一下
  if (process.client) {
    let token = getUrlQuery(HostRouteParamsEnum.TOKEN);
    let userSubject =
      getUrlQuery(HostRouteParamsEnum.SUBJECT_ID) ||
      window.localStorage.getItem(StorageKeyEnum.HOST_PROGRAM_SUBJECT_ID); // 小程序那边的科目id

    const userSubjectNameParam = getUrlQuery(HostRouteParamsEnum.SUBJECT_NAME);

    // 如果 userSubjectNameParam 存在且不为 null，则解码它,小程序传来都是加码的
    let userSubjectName: string = '';

    if (
      userSubjectNameParam !== null &&
      userSubjectNameParam !== undefined &&
      userSubjectNameParam !== ''
    ) {
      userSubjectName = decodeURIComponent(userSubjectNameParam.toString());
    }

    try {
      token && (await miniProgramToPc({ 'user-token': token }));

      if (!token && userSubjectNameParam) {
        // 初次进入的时候才触发token 为空的时候才退出登录
        // 试用img删除的可行；因为接口删除不了（必须跳转home下才能）
        var img = document.createElement('img');
        img.src = `${GLOBAL_CONFIG.envConfig.eduUrl}/center/user/index/logout`;
        document.body.appendChild(img);
        document.body.removeChild(img);
      }

      userSubject && userStore.updateMiniProgramSubjectId(userSubject);
      // 小程序传来的(科目的名称，为空也赋值,个人中心小程序的title 需要这个)（可以标识小程序是从个人中心跳转来的）
      userStore.updateMiniProgramSubjectName(userSubjectName);
    } catch (error) {
      APIEventEmitter.emit(EventNameMap.API_UN_LOGIN, error);
      console.error(error);
    }
  }
}

// 如果是app环境
// 强制改为app环境

if (envStore.platform === PlatformEnum.APP) {
  if (process.client) {
    let userSubject =
      String(getUrlQuery(HostRouteParamsEnum.SUBJECT_ID)) !== '0' &&
      String(getUrlQuery(HostRouteParamsEnum.SUBJECT_ID)) !== ''
        ? getUrlQuery(HostRouteParamsEnum.SUBJECT_ID)?.toString()
        : window.localStorage.getItem(StorageKeyEnum.HOST_PROGRAM_SUBJECT_ID) || ''; // app那边的科目id,没有就是空或者0

    try {
      // 需要app 内登录不，需要的话用token登录
      UserCenterStore.updateSubjectId(userSubject ?? '');
      userStore.updateAppProgramSubjectId(userSubject ?? '');
    } catch (error) {
      console.error(error);
    }
  }

  // app主题
  appSettingStore.updateAppTheme('app-blue');
}

if (process.client) {
  await userStore.updateUserInfo({
    nuxtApp,
  });

  if (
    userStore.userMeta.isLogin &&
    !userStore.userMeta.subjectId &&
    envStore.platform !== PlatformEnum.APP
  ) {
    await Promise.all([userStore.getUserSubjectId({ nuxtApp })]);
  }
}
</script>
